module.exports = __webpack_public_path__ + "img/hero_2.14ccd4eb.jpg";